import { React, useMemo } from 'react';

import styled from 'styled-components';
import moment from 'moment';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';
import SalesDaily from './SalesDaily';

export default function SalesCalendarWeekRow(props) {
  const {
    weekData,
    standardDate,
    selectedDate,
    salesDailyRef,
    disableOpacity,
    onClickDateBox,
    onClickClose,
    onClickSalesItem
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const today = useMemo(() => moment(), []);

  // 요일에 따른 날짜 색상 //
  function decideDateFontColor(date) {
    if (date.day() === 0) return theme.pointRed;
    if (date.day() === 6) return theme.pointBlue;

    return theme.text;
  }

  // 해당 월에 따른 Opacity //
  function decideDateOpacity(date) {
    if (disableOpacity) return 1;
    if (date.month() === standardDate.month() && date.year() === standardDate.year()) return 1;

    return 0.2;
  }

  // 선택된 날짜가 이 주에 포함되는지 //
  function isSelectedDateInThisWeek() {
    if (!selectedDate) return false;

    return weekData.some(data => data.date.isSame(selectedDate, 'day'));
  }

  // 선택된 날짜의 매출 데이터 //
  function getSelectedDateSales() {
    if (!selectedDate) return [];

    const matched = weekData.find(data => data.date.isSame(selectedDate, 'day'));

    return matched?.sales || [];
  }

  return (
    <WeekRow>
      {
        weekData.map((data, index) => (
          <DateBox
            key={'calendar-' + index}
            opacity={decideDateOpacity(data.date)}
            $isDark={isDark}
            onClick={() => onClickDateBox(data.date)}>
            <DateWrapper>
              <Text fontFamily='NotoSansKR-Regular' size={14} color={decideDateFontColor(data.date)} cursor='inherit'>{data.date.date()}</Text>
              {
                data.date.isSame(today, 'day') &&
                <TodayComponent>
                  <Text fontFamily='NotoSansKR-Medium' size={10} color={theme.white} cursor='inherit'>{t('statistics.salesCalendar.today')}</Text>
                </TodayComponent>
              }
            </DateWrapper>
            {
              data.salesPrice > 0 &&
              <PriceWrapper>
                <Text fontFamily='NotoSansKR-Regular' size={14} color={theme.text} cursor='inherit'>{data.salesPrice.toLocaleString('ko-KR')}</Text>
              </PriceWrapper>
            }
            {
              data.settlementPrice > 0 &&
              <PriceWrapper>
                <Text fontFamily='NotoSansKR-Regular' size={14} color={theme.subKey} cursor='inherit'>{data.settlementPrice.toLocaleString('ko-KR')}</Text>
              </PriceWrapper>
            }
          </DateBox>
        ))
      }
      {
        isSelectedDateInThisWeek() &&
        <TotalModalWrapper>
          <SalesDailyWrapper ref={salesDailyRef}>
            <SalesDaily
              date={selectedDate}
              data={getSelectedDateSales()}
              onClickClose={onClickClose}
              onClickSalesItem={onClickSalesItem} />
          </SalesDailyWrapper>
        </TotalModalWrapper>
      }
    </WeekRow>
  );
}

const WeekRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 8px;
`;

const DateBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 24px;

  min-width: 112px;
  height: 74px;

  padding: 5px;
  border-radius: 5px;
  border: 1px solid transparent;

  opacity: ${props => props.opacity};

  &:hover {
    border: 1px solid ${props => props.theme.brand500};
    background-color: ${props => props.theme.brand500Alpha5};
    cursor: pointer;
  }
`;

const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-bottom: 12px;

  gap: 8px;
`;

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
`;

const TodayComponent = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 31px;
  height: 17px;

  border-radius: 8px;
  background-color: ${props => props.theme.brand500};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.size}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const SalesDailyWrapper = styled.div``;
